import React, { useState, useEffect } from 'react';
import GoodsInfoSimpleDisplay from '../goods-info-simple-display';
import { dynamicGoodsDetailRequest } from '@service';
import { Spin, DatePicker } from 'antd';
import './index.less';
import moment from 'moment';

const DynamicData = ({ goodsInfo }) => {
  const { goods_basicid, start_time, end_time } = goodsInfo;
  const [sellingData, setSellingData] = useState({});
  const [s_time, setSTime] = useState(start_time);
  const [e_time, setETime] = useState(end_time);

  const [spinning, setSpinning] = useState(true);

  const requestData = async () => {
    setSpinning(true);
    const { flag, data } = await dynamicGoodsDetailRequest({ goods_basicid, start_time:s_time, end_time:e_time });

    if (flag === 200) {
      if (!s_time && !e_time) {
        setSTime(data.start_time);
        setETime(data.end_time);
      }
      setSellingData(data);
      setSpinning(false);
    }
  };

  useEffect(() => {
    if (goods_basicid) {
      requestData();
      const timer = setInterval(() => {
        requestData();
      }, 2500);

      return () => {
        clearInterval(timer);
      };
    }
  }, [goods_basicid, s_time, e_time]);

  const onChange = (dates, dateStrings) => {
    setSTime(dateStrings[0]);
    setETime(dateStrings[1]);
  };

  return (
    <React.Fragment>
      <GoodsInfoSimpleDisplay generalInfo={goodsInfo} />

      {s_time && e_time && (
        <DatePicker.RangePicker
          format="YYYY-MM-DD HH:mm:ss"
          showTime={true}
          defaultValue={[moment(s_time), moment(e_time)]}
          onChange={onChange}
        />
      )}

      <Spin spinning={spinning}>
        <div className="flex-inline-start-space">
          <p>
            待发货销量：<span className="bold-instance">{sellingData.waiting_for_deliver_sales}</span>
          </p>
          <p>
            待付款销量：<span className="bold-instance">{sellingData.waiting_for_pay_sales}</span>
          </p>
          <p>
            库存：<span className="bold-instance">{sellingData.storage}</span>
          </p>
          <p>
            支付后取消的销量：<span className="bold-instance">{sellingData.paid_cancel_sales}</span>
          </p>
          <p>
            总销量：<span className="bold-instance">{sellingData.all_sales}</span>
          </p>
        </div>
      </Spin>
      <p className="conspicuous-red ant-statistic-content">销量数据仅支持秒杀商品</p>
    </React.Fragment>
  );
};

export default DynamicData;
